import { getDataClass, DataItem } from 'scrivito'

import { DataClassName } from '@/Data/const'
import { TimerecordTeam } from '@/Data/TimerecordTeam/TimerecordTeamDataClass'
import { ensureString } from '@/utils/ensureString'
import { getDataItem } from '@/utils/getDataItem'

export interface UserOption {
  label: string
  value: string
}

export interface TeamMembersResult {
  members: UserOption[]
  totalMembers: number
  hasMore: boolean
}

export const useTeamMembers = (
  currentUserId: string,
  limit?: number,
): TeamMembersResult => {
  const isAll = currentUserId === 'all'
  const baseScope = TimerecordTeam.all().transform({
    ...(!isAll ? { filters: { leader: currentUserId } } : {}),
  } as object)

  const paginatedScope = limit
    ? baseScope.transform({ limit: limit + 1 } as object)
    : baseScope

  const teams = paginatedScope.take()
  const hasMore = Boolean(limit && teams.length > limit)
  const visibleTeams = hasMore ? teams.slice(0, limit) : teams

  const userIds = [
    ...new Set([
      ...(!isAll ? [currentUserId] : []),
      ...visibleTeams
        .map((item) => ensureString(item.get('member')))
        .filter(Boolean),
    ]),
  ]

  const members = userIds
    .map(
      (id) =>
        getDataItem(getDataClass(DataClassName.TIMERECORD_USER)!, id).dataItem,
    )
    .filter((user): user is DataItem => user != null)
    .map((user) => ({
      label: ensureString(user.get('name')),
      value: user.id(),
    }))

  const totalMembers = isAll
    ? baseScope.count() || members.length
    : (baseScope.count() || 0) + 1

  return { members, totalMembers, hasMore }
}
